import { CmsPageView } from '../components/CmsPageView';

export default function CancellationPolicyPage() {
  return <CmsPageView code="CANCELLATION_POLICY" fallbackTitle="Cancellation Policy" />;
}
